import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../context/UserContext";
import { getSingleAccount } from "../../../controllers/accounts/accounts";
import { CircularProgress, Button, Typography, Box, Card, CardContent, Container } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import { ProfileQuesitons } from "./profile_questions";
import { ProfileCompleteContext } from "../../../context/ProfileComplete";
import { MainLoggedInLayout } from "../../layouts/main.loggedIn.layout";

export const ProfileEdit = () => {
  const navigate = useNavigate();
  const { userDetails } = useContext(UserContext);

  const [refresh, setRefresh] = useState(true);
  const { profileComplete } = useContext(ProfileCompleteContext);
  const [user, setUser] = useState(null);

 
  useEffect(() => {
    const localUser = async () => {
      try {
        setUser(await getSingleAccount(userDetails?.id, userDetails?.token))

      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    }
    if(userDetails?.id && userDetails?.token){
      localUser()
    }
  }, [userDetails, refresh]);
  


  if(!user) {
    return (
      <Container maxWidth="sm" sx={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  const renderedView = () => {
    return (
      <Container maxWidth="sm" sx={{ mt: 4, mb: 4 }}>
        <Card elevation={3} sx={{ borderRadius: 3 }}>
          <CardContent>
            <Box mb={2}>
              <Typography variant="h5" align="center" gutterBottom>
                Edit Your Profile
              </Typography>
            </Box>
            <ProfileQuesitons
              register_page={false}
              userDetails={userDetails}
              profile={user?.mastodon?.user[0]}
              token={userDetails?.token}
              setRefresh={setRefresh}
              refresh={refresh}
            />
            {profileComplete && (
              <Box display="flex" justifyContent="center" mt={3}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<GroupIcon />}
                  onClick={() => navigate("/")}
                  sx={{ px: 4, py: 1.5, fontWeight: 600 }}
                >
                  Start making friends
                </Button>
              </Box>
            )}
          </CardContent>
        </Card>
      </Container>
    );
  };

  if(!userDetails?.id || !userDetails?.token){
    return (
      <Container maxWidth="sm" sx={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <>
      {
        !profileComplete ? (
          <>
            <Box p={2} bgcolor="primary.main" color="white" sx={{ marginBottom: 3, borderRadius: 2 }}>
              <Typography variant="h6" align="center">Complete Your Profile</Typography>
            </Box>
            {renderedView()}
          </>
        ) : (
          <MainLoggedInLayout>
            {renderedView()}
          </MainLoggedInLayout>
        )
      }
    </>
  );
};